import React, { useState } from "react";
import { NotebookText } from "lucide-react";
import { cn } from "../../../../src/lib/utils";
import ClosureNoteModal from "../../recommendations/components/ActionAgainstInvolvedPartiesTable/ClosureNoteModal";


interface ViewNotesButtonProps {
  note?: string;
}

export const ViewNotesButton: React.FC<ViewNotesButtonProps> = ({
  note = "",
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  return (
    <>
      <button
        onClick={handleOpen}
        className={cn(
          "flex items-center gap-1 px-2 py-0.5",
          "rounded-lg border border-transparent",
          "bg-[#F3F4F6] hover:bg-[#E5E7EB]",
          "text-[#4B5563]",
          "text-xs font-medium leading-4",
          "transition-colors"
        )}
      >
        <NotebookText className="h-3 w-3" />
        <span>View Notes</span>
      </button>

      <ClosureNoteModal
        isOpen={isOpen}
        onClose={handleClose}
        variant="view"
        initialNote={note}
        titleOverride="View Notes"
      />
    </>
  );
};